import script from "./SceneDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneDetail.vue?vue&type=script&setup=true&lang=js"

import "./SceneDetail.vue?vue&type=style&index=0&id=2c41f55a&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c41f55a"]])

export default __exports__